<template>
	<div class="flex mr-6 justify-center ">
		<base-modal ref="editTeeModal">
			<template v-slot:modal-button="{ showModal }">
				<button @click="showModal" class="ml-auto button is-small">
					<font-awesome-icon icon="book-open" />
				</button>
			</template>
			<div class="bg-white p-4">
				<course-scorecard
					:golf-course="golfCourse"
					:round-mode="false"
					:scorecard-holes="teeData.holes"
					:course-tee="teeData"
					@tee-updated="teeUpdated"
				></course-scorecard>
				<div class="field is-grouped flex justify-center">
					<div class="control">
						<base-button @click="saveTeeData" :disabled="savingTee">Save</base-button>
					</div>
				</div>
			</div>
		</base-modal>
		<course-tee-title :tee-hex="teeData.hex" :tee-name="teeData.tee"></course-tee-title>
	</div>
</template>
<script>
/** @format */

export default {
	name: 'CourseTees',
	components: {
		'course-scorecard': () => import(/* webpackChunkName: "CourseScorecard" */ './Scorecard'),
		'course-tee-title': () => import(/* webpackChunkName: "CourseTeeTitle" */ './TeeTitle')
	},
	props: {
		courseTee: {
			type: Object,
			required: true
		},
		golfCourse: {
			type: Object,
			required: true
		}
	},
	methods: {
		saveTeeData() {
			this.savingTee = true;
			this.$store.dispatch('notification/add', {type: 'info', message: 'Saving course data.'});
			this.$store
				.dispatch('courses/editTee', {golfCourse: this.golfCourse, courseTee: this.teeData})
				.then((response) => {
					this.$refs.editTeeModal.closeModal();
					this.$store.dispatch('notification/add', {type: 'success', message: 'Course tee data saved successfully.'});
					this.teeData = response.data.data;
				})
				.finally(() => {
					this.savingTee = false;
				});
		},
		teeUpdated(courseTee) {
			this.teeData = courseTee;
		}
	},
	data() {
		return {
			savingTee: false,
			teeData: this.courseTee
		};
	}
};
</script>
